import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Rule } from '../../models/rule';

export const RULES_ACTIONS = {
  SET_RULES: 'SET_RULES',
  UPDATE_RULE: 'UPDATE_RULE',
  DELETE_RULE: 'DELETE_RULE',
  ADD_RULE: 'ADD_RULE'
};

@Injectable()
export class RulesActions {

  constructor(private store: Store<Rule[]>) { }

  setRules(rules: Rule[]) {
    this.store.dispatch({ type: RULES_ACTIONS.SET_RULES, payload: rules });
  }

  updateRule(rule: Rule) {
    this.store.dispatch({ type: RULES_ACTIONS.UPDATE_RULE, payload: rule });
  }

  deleteRule(rule: Rule) {
    this.store.dispatch({ type: RULES_ACTIONS.DELETE_RULE, payload: rule });
  }

  addRule(rule: Rule) {
    this.store.dispatch({ type: RULES_ACTIONS.ADD_RULE, payload: rule });
  }
}



// WEBPACK FOOTER //
// ./src/app/store/actions/rules.actions.ts